module.exports = __webpack_public_path__ + "img/company.335a6752.png";